<div class="flex-row justify-content-center f-1-0" *ngIf="getConfigInProcess && !configModels">
	<loader height="100" width="100" style="opacity: 0.8;"></loader>
</div>

<div class="list-group list-group-flush settings-list-container animated fadeIn" *ngIf="configModels">
	<div class="list-group-item settings-list-item">
		<div class="flex-column w-100 border rounded-2">
			<div class="flex-column border-bottom gap-1 p-3" style="background: #f8fafc; color: #1e293b;">
				<span class="fw-bold" style="font-size: 14px;">Protection Mode</span>
				<span>Default actions for assets detected by Collaboration Protection </span>
			</div>
			<div class="flex-column gap-1 p-4">
				<div class="flex-row gap-5 align-items-center">
					<div class="flex-row gap-2 align-items-center" style="flex-basis: 215px;">
						<i class="far fa-bug text-danger"></i>
						<span>Threat Detection</span>
					</div>
					<div class="flex-row gap-4 align-items-center" style="font-size: 14px;">
						<checkbox id="maliciousKeepRecord" class="transparent-box success-color"
								  (click)="$event.preventDefault(); toggleAction(configModels.policy.malicious_detected.actions, dic.CONSTANTS.collaborationActions.keepRecord)"
								  [model]="configModels.policy.malicious_detected.actions.includes(dic.CONSTANTS.collaborationActions.keepRecord)">
							<span class="fw-500">
								Keep Record
							</span>
							<i style="font-weight: 400; position: relative; bottom: 5px;" class="far fa-question-circle"
							   tooltip="The information will be saved in the Assets page"
							   (click)="$event.stopPropagation();"></i>
						</checkbox>
						<checkbox id="maliciousNotifyReviewer" class="transparent-box success-color"
								  (click)="$event.preventDefault(); toggleAction(configModels.policy.malicious_detected.actions, dic.CONSTANTS.collaborationActions.notifyReviewer)"
								  [model]="configModels.policy.malicious_detected.actions.includes(dic.CONSTANTS.collaborationActions.notifyReviewer)">
								<span class="fw-500">
									Notify Reviewer
								</span>
							<i style="font-weight: 400; position: relative; bottom:5px;" class="far fa-question-circle"
							   tooltip="Reviewers will receive an email report explaining the detected threats"></i>
						</checkbox>

						<checkbox id="maliciousQuarantineFile" class="transparent-box success-color"
								  (click)="$event.preventDefault(); toggleAction(configModels.policy.malicious_detected.actions, dic.CONSTANTS.collaborationActions.quarantine)"
								  [model]="configModels.policy.malicious_detected.actions.includes(dic.CONSTANTS.collaborationActions.quarantine)">
								<span class="fw-500">
									Quarantine File
								</span>
							<i style="font-weight: 400; position: relative; bottom:5px;" class="far fa-question-circle"
							   tooltip="Malicious files will be quarantined in a dedicated SharePoint site"></i>
						</checkbox>
					</div>
				</div>
				<hr class="opacity-25">
				<div class="flex-row gap-5 align-items-center">
					<div class="flex-row gap-2 align-items-center" style="flex-basis: 215px;">
						<i class="far fa-exclamation-triangle text-warning"></i>
						<span>Sensitive Data Detection</span>
					</div>
					<div class="flex-row gap-4 align-items-center" style="font-size: 14px;">
						<checkbox id="sensitivityKeepRecord" class="transparent-box success-color"
								  (click)="$event.preventDefault(); toggleAction(configModels.policy.sensitivity_detected.actions, dic.CONSTANTS.collaborationActions.keepRecord)"
								  [model]="configModels.policy.sensitivity_detected.actions.includes(dic.CONSTANTS.collaborationActions.keepRecord)">
								<span class="fw-500">
									Keep Record
								</span>
							<i style="font-weight: 400; position: relative; bottom:5px;"
							   class="far fa-question-circle"
							   tooltip="The information will be saved in the Assets page"></i>
						</checkbox>
						<checkbox id="sensitivityNotifyReviewer" class="transparent-box success-color"
								  (click)="$event.preventDefault(); toggleAction(configModels.policy.sensitivity_detected.actions, dic.CONSTANTS.collaborationActions.notifyReviewer)"
								  [model]="configModels.policy.sensitivity_detected.actions.includes(dic.CONSTANTS.collaborationActions.notifyReviewer)">
								<span class="fw-500">
									Notify Reviewer
								</span>
							<i style="font-weight: 400; position: relative; bottom:5px;"
							   class="far fa-question-circle"
							   tooltip="Reviewers will receive an email report explaining the detected sensitive content"></i>
						</checkbox>
						<checkbox id="sensitivityQuarantineFile" class="transparent-box success-color"
								  (click)="$event.preventDefault(); toggleAction(configModels.policy.sensitivity_detected.actions, dic.CONSTANTS.collaborationActions.quarantine)"
								  [model]="configModels.policy.sensitivity_detected.actions.includes(dic.CONSTANTS.collaborationActions.quarantine)">
								<span class="fw-500">
									Quarantine File
								</span>
							<i style="font-weight: 400; position: relative; bottom:5px;" class="far fa-question-circle"
							   tooltip="Sensitive files, excluding images, will be quarantined in a dedicated SharePoint site"></i>
						</checkbox>
					</div>
				</div>
				<btn-c class="mt-4 popup-action-btn"
					[isDisabled]="updatePolicyInProcess || !isModelChanged"
					(action)="updatePolicyProtectionMode();">
					Apply
				</btn-c>
			</div>
		</div>
	</div>

	<div class="list-group-item settings-list-item">
		<div class="title-section-container flex-column gap-2">
			<b>Enable Quarantine Storage</b>
			<span class="lh-base" style="font-size: 0.9em;">
				Permit the creation of a hidden SharePoint site where quarantined items will be stored.
			</span>
		</div>
		<div class="content-container">
			<btn-c class="popup-action-btn"
				   *ngIf="!config.collaboration_protection?.microsoft?.quarantine_drive"
				   [isDisabled]="updatePolicyInProcess"
				   (action)="createQuarantineSite();">
				Enable Storage
			</btn-c>
			<btn-c class="popup-action-btn cursor-default" style="pointer-events: none;"
				   color="success" variant="outlined"
				   *ngIf="config.collaboration_protection?.microsoft?.quarantine_drive"
				   startIcon="far fa-check">
				Enabled Successfully
			</btn-c>
		</div>
	</div>

	<div class="list-group-item settings-list-item">
		<div class="title-section-container flex-column gap-2">
			<b>Sensitive Data Detection</b>
			<span class="lh-base" style="font-size: 0.9em;">
				Set the minimum sensitivity score required for collaboration assets to be flagged for DLP activity.
			</span>
		</div>
		<div class="content-container flex-column gap-3">
			<div class="flex-row gap-2 align-items-center">
				<span>Minimum Sensitivity Score:</span>
				<div class="flex-row gap-2 align-items-center">
					<input required
						   [(ngModel)]="configModels.policy.sensitivity_threshold"
						   style="width:60px; height: inherit; margin-bottom:0; box-sizing: border-box; border-radius: 4px; border: 1px solid #ccc; padding: 2px 8px;"
						   type="number" min="1" max="5" step="0.1"
						   pattern="/^[1-5]\.?[0-9]?$/">
				</div>
				<btn-c style="min-width: 0;"
					   endIcon="zmdi zmdi-check"
					   [isDisabled]="updatePolicyInProcess || configModels.policy.sensitivity_threshold === config.collaboration_protection.policy.sensitivity_threshold"
					   (action)="updatePolicySensitivityThreshold();">
				</btn-c>
			</div>
		</div>
	</div>
</div>
